import axios from "_u/axios"

// 查询列表
export const sMeterList = (body) => {
    return axios.post("api/setting/meter/list", body)
}

// 查看详情
export const sMeterView = (id) => {
    return axios.post("api/setting/meter/view", { id })
}

// 新增电子表
export const sMeterAdd = (body) => {
    return axios.post("api/setting/meter/add", body)
}

// 更新电子表
export const sMeterUpdate = (body) => {
    return axios.post("api/setting/meter/update", body)
}

// 启用/禁用电子表 
export const sMeterEnable = (id) => {
    return axios.post("api/setting/meter/enable", { id })
}

// 水电设置列表
export const smartmeterList = () => {
    return axios.post("api/setting/smartmeter/list")
}

// 水电设置详情
export const smartmeterView = (houseId) => {
    return axios.post("api/setting/smartmeter/view", { houseId })
}

// 设置单价(单个/批量)
export const smartmeterSetting = (body) => {
    return axios.post("api/setting/smartmeter/setting", body)
}